// ログイン画面(HQ・各社スタッフ共通)。ログイン後、roleに応じて適切な画面へ遷移する。
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

export function LoginPage() {
  const { user, claims, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user && claims?.role === "hq") return <Navigate to="/" replace />;
  if (!loading && user && claims?.role === "staff" && claims.companyId) {
    return <Navigate to={`/c/${claims.companyId}`} replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
    } catch {
      setError("メールアドレスまたはパスワードが正しくありません");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main style={{ maxWidth: 380, margin: "80px auto" }}>
      <div className="card">
        <h2>
          <span className="ic">💊</span>薬局 情報伝達ハブ
        </h2>
        <form onSubmit={handleSubmit}>
          <label className="f">メールアドレス</label>
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          <label className="f">パスワード</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          {error && <div className="banner" style={{ marginTop: 12 }}>{error}</div>}
          <div className="row" style={{ marginTop: 16 }}>
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "ログイン中…" : "ログイン"}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}
